<div>
    <h2>{{"PP.CHANGE_FOLDER_NAME" | translate}}</h2>
    <div>
        <form [formGroup]="form" fxLayout="row wrap">

            <mat-form-field fxFlex="0 1 100" appearance="outline" floatLabel="always" class="m-8">
                <mat-label>
                    {{ 'PP.CURRENT_NAME' | translate }}
                </mat-label>
                <input matInput formControlName="nameFolder" autocomplete="off" class="mt-4"
                    [maxlength]="textFiltersMaxLength">
            </mat-form-field>
        </form>
    </div>
    <div align="end">
        <button mat-raised-button color="secondary" class="m-8" (click)="onCancel()">
            {{"PP.NEW_FOLDER.DIALOG.BUTTONS.CANCEL" | translate}}
        </button>
        <button mat-raised-button color="primary" class="m-8 px-8" (click)="onSave()" [disabled]="form.invalid">
            {{"BUTTONS.SAVE" | translate}}
        </button>
    </div>
</div>
